import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, styled, Typography } from "@mui/material";
import ChooseAService from "~/images/cicd/choose-a-service.png";
import ChooseAServiceLight from "~/images/cicd/choose-a-service-light.png";
import Setup from "~/images/cicd/setup.png";
import SetupLight from "~/images/cicd/setup-light.png";
import BuildAndDeploy from "~/images/cicd/build-deploy.png";
import BuildAndDeployLight from "~/images/cicd/build-deploy-light.png";
import { useColorMode } from "~/providers/color-mode";
import { CanCreate } from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";

type Props = {
  spaceId: string;
};

export function ProjectsSplash({ spaceId }: Props) {
  let navigate = useNavigate();
  const { mode } = useColorMode();
  return (
    <Box id="projects-splash-screen" m="auto" my={5} maxWidth={896}>
      <Typography
        variant="h5"
        color="text.secondary"
        fontWeight={700}
        lineHeight="48px"
        textAlign="center"
        mb={10}
      >
        Use Mondoo to apply security policies to your CI/CD pipelines:
      </Typography>
      <Grid
        container
        justifyContent="center"
        columnSpacing={{ sm: 2, md: 0 }}
        rowSpacing={{ xs: 8, sm: 0 }}
      >
        <Grid
          display="flex"
          justifyContent={{ xs: "center", sm: "start" }}
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Box maxWidth={208} px="9.5px">
            <Box
              component="img"
              src={mode === "light" ? ChooseAServiceLight : ChooseAService}
              alt="Choose a CI/CD service to integrate with"
              width="100%"
              mb={2}
            />
            <StyledText>Choose a CI/CD service to integrate with</StyledText>
          </Box>
        </Grid>
        <Grid
          display="flex"
          justifyContent="center"
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Box maxWidth={208}>
            <Box
              component="img"
              src={mode === "light" ? SetupLight : Setup}
              alt="Set up your integration and choose your policies"
              width="100%"
              mb={2}
            />
            <StyledText>
              Set up your integration and choose your policies
            </StyledText>
          </Box>
        </Grid>
        <Grid
          display="flex"
          justifyContent={{ xs: "center", sm: "end" }}
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Box maxWidth={208}>
            <Box
              component="img"
              src={mode === "light" ? BuildAndDeployLight : BuildAndDeploy}
              alt="Builds and deploys will automatically show up here"
              width="100%"
              mb={2}
            />
            <StyledText>
              Builds &amp; deploys will automatically show up here
            </StyledText>
          </Box>
        </Grid>
      </Grid>
      <CanCreate>
        <Button
          data-name="CiCd-add-first-integration"
          onClick={() =>
            navigate(`/space/integrations/add?spaceId=${spaceId}#cicd`)
          }
          sx={{
            display: "block",
            mt: 10,
            ml: "auto",
            mr: "auto",
            px: 2,
            background: (theme) => theme.palette.primary.gradient,
            color: "common.white",
          }}
        >
          ADD your first integration
        </Button>
      </CanCreate>
    </Box>
  );
}

const StyledText = styled(Typography)`
  color: ${(p) => p.theme.palette.text.secondary};
  font-weight: 600;
  line-height: 24px;
  text-align: center;
`;
